define('views/components/wallet_history/wallet_history_list',['require','views/base/list_view','views/components/wallet_history/wallet_history','text!templates/components/wallet_history/wallet_history_list.html'],function(require){

    var BaseListView = require('views/base/list_view');
    var ChildView = require('views/components/wallet_history/wallet_history');

    var temp = require("text!templates/components/wallet_history/wallet_history_list.html");
    return BaseListView.extend({
        template: _.template(temp),
        childView: ChildView
    });
});

